module.exports = __webpack_public_path__ + "static/media/earth.88adc019.png";